const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const aircraftmapLegendFactory = require('components/bags_and_seats/aircraftmap_legend/js/main.mobile');
const DrawerModel = require('components/ui/drawer/js/model');
const drawerAircraftmapLegendFactory = require('components/bags_and_seats/drawer_aircraftmap_legend/js/main');

const AirCraftMapWidgetHelper = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.helper');
const aircraftMapUtils = require('components/bags_and_seats/aircraftmap_utils/js/aircraftmap.utils');
const AircraftMapTemplate = require('components/bags_and_seats/aircraftmap/js/aircraftmap_mobile');
const SeatsTracking = require('../../../../webapp/static-content/_versionedByRelease_/js/tracking/bags_and_seats/seats_tracking').getInstance();

const CONS = {
    DATA_STATUS: 'data-status',
    STATUS_AVAILABLE: 'available',
    STATUS_UNAVAILABLE: 'unavailable',
    STATUS_ACTIVE: 'active',
    STATUS_INACTIVE: 'inactive',
    STATUS_SELECTED: 'selected',
    STATUS_VISIBLE: 'visible',
    STATUS_HIDDEN: 'hidden',
    STATUS_CLOSED: 'closed',
    STATUS_NO_SEAT: 'no_seat',
    EXTRA_LEG: 'EXTRA_LEG',
    SCROLL_SEAT_OFFSET: 85,
    TIMEOUT_NO_SEATS_AUTO_MOVE: 4000,
    TIMEOUT_DIALOG_OK: 1400,
    TIMEOUT_DIALOG_MOVE_SECTION: 1400,
    TAB_SCROLL_ANIMATION_TIME: 200,
    AIRCRAFT_MOBILE_ID: 'aircraftmap-checkin-mobile',
    PASSENGER_TYPE_INFANT: 'INFANT',
    NUM_SELECTED_SEATS: 'numSelected_seats',
    SELECTED_SEAT_SELECTOR: '.aircraftmap_seat[data-status="selected"],.aircraftmap_seat[data-status="active"]',
    AVAILABLE_SEAT_SELECTOR: '.aircraftmap_seat[data-status="available"]',
};
module.exports = withRenderedMain(withCachedSelectors(BaseView.extend(AirCraftMapWidgetHelper.extend({
    selectors: {
        aircrafmapFlightSectionText: '.aircrafmap_flight_section_text',
        aircrafmapFlightSectionTextDetail: '.aircrafmap_flight_section_text_detail',
        aircraftContainer: '.aircraftmap_container',
        aircraftmapConfirmContainer: '.aircraftmap_confirm_container',
        aircraftmapConfirmButton: '.aircraftmap_confirm_button',
        aircraftmapRandomSelectionButton: '.aircraftmap_random_selection_button',
        aircraftmapCancelSelectionWrapper: '.cancel_seat_selection_wrapper',
        aircraftmapCancelSelection: '.cancel_seat_selection',
        aircraftmapContent: '.aircraftmap_content',
        aircraftmapMovePrevSection: '.aircraftmap_move_prev_section_wrapper',
        aircraftmapMoveNextSection: '.aircraftmap_move_next_section_wrapper',
        aircraftmapNextSectionIata: '.aircraftmap_next_iata',
        aircraftmapPrevSectionIata: '.aircraftmap_prev_iata',
        aircraftmapEmergentLayer: '.aircraftmap_emergent_layer',
        aircraftmapTextBlockPrice: '.aircraftmap-textblock-price',
        aircraftmapUidialogDelete: '.aircraftmap_ui_dialog_delete',
        aircraftmapUidialogOK: '.aircraftmap_ui_dialog_OK',
        aircraftmapUiDialogNextFlight: '.aircraftmap_ui_dialog_next_flight',
        aircraftmapNextSectionItinerary: '.aircraftmap_next_section_itinerary',
        aircraftmapNextSectionDepartureDate: '.aircraftmap_next_section_departure_date',
        aircraftmapNoSeatmapWrapper: '.aircraftmap_no_seatmap_wrapper',
        aircraftmapSeatmapWrapper: '.aircraftmap_seatmap_wrapper',
        aircraftmapNoSeatmapButtonTextLast: '.aircraftmap_no_seatmap_button_text_last',
        aircraftmapNoSeatmapButtonText: '.aircraftmap_no_seatmap_button_text',
        aircraftmapWrapper: '.aircraftmap_wrapper',
        aircraftmapPassengerTabContainer: '.aircraftmap_passenger_tab_container',
        aircraftmapPrimePillContainer: '.aircraftmap_prime_pill_container',
        aircraftmapInfantMessage: '.infant_message',
        aircrafmapLegend: '.aircrafmap_legend',
        aircraftmapLegendSidebarWrapper: '.aircraftmap_legend_sidebar_wrapper',
        aircraftmapLegendLink: '.aircraftmap_legend_link',
        aircraftmapLegendTooltipContainer: '.aircraftmap_legend_tooltip_container',
        aircraftmapSavedAmountItinerary: '.aircraftmap_saved_amount_itinerary',
        aircraftmapSavedAmount: '.aircraftmap_saved_amount',
    },
    events: {
        'tap .aircraftmap_confirm_button': 'onTapConfirmSeats',
        'tap .aircraftmap_random_selection_button': 'onTapRandomSelectionSeats',
        'tap .cancel_seat_selection': 'onTapCancelSeatSelection',
        'tap .aircraftmap_move_prev_section_wrapper': 'onTapMoveToOtherSection',
        'tap .aircraftmap_move_next_section_wrapper': 'onTapMoveToOtherSection',
        'tap .aircraftmap_no_seatmap_wrapper': 'onTapMoveToNextSection',
        'tap .aircraftmap_ficon_back': 'onTapIconBack',
        'tap .aircraftmap_seat': 'onTapSeat',
        'tap .aircraftmap_upbutton': 'onTapUpAircraftMap',
        'tap .aircraftmap_user_delete': 'onTapDeleteButton',
        'tap .aircraftmap_seat_legend_icon': 'onOpenSidebarLegendFromIcon',
        'tap .aircraftmap_legend_link': 'onOpenSidebarLegendFromLink',
    },
    nTravellers: 0,
    nEligibleTravellers: 0,
    defaultPassengerSelectString: '',
    segment: '',
    section: '',
    flightSection: '',
    seatMap: [],
    infantMessageDismissed: false,
    drawerAircraftmapLegend: null,
    buildTemplate: function(options) {
        const opts = Odigeo._.extend({
            keys: {
                unavailable: this.keys.unavailable,
                window: this.keys.window,
                aisle: this.keys.aisle,
                middle: this.keys.middle,
                textBlockTitle: this.keys.textBlockTitle,
                rowPrice: this.keys.rowPrice,
                darkzoneSingleRow: this.keys.darkzoneSingleRow,
                darkzoneMultiRow: this.keys.darkzoneMultiRow,
            },
            prismaHeader: Odigeo.AB.prismaHeader,
            seatMap: this.seatMap,
        }, options);
        const aircraftMapTemplate = new AircraftMapTemplate(opts);
        return aircraftMapTemplate.buildTemplate();
    },
    onTapIconBack: function(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        if (this.isCheckin() && this.isPristineMoveThrough) {
            this.onTapBackCheckin();
        } else {
            this.onTapIconBackClose(true);
        }
        SeatsTracking.trackSeatsWidgetClick('back');
    },
    onTapBackCheckin() {
        if (this.isFirstSection()) {
            if (this.seatMapSelectionCollection.hasSelectedAnySeat()) {
                this.onTapIconBackClose(true);
            } else {
                Odigeo.trigger(`${this.name}:resetCheckInSeatSelectionStep`);
            }
        } else {
            const moveToOtherSectionEventId = `moveToOtherSection${this.getCheckinEventSuffix()}`;
            Odigeo.trigger(`${this.name}:${moveToOtherSectionEventId}`, this.prevAircraftData);
        }
    },
    onTapIconBackClose: function(fromBackIcon) {
        this.disablePristineMoveThrough();
        this.closeAircraftMap({fromBackIcon});
        if (Odigeo.AB.isOpenedSeatmapOnContinuance) {
            this.resetDefaultBehaviourAfterOpenedSeatmap();
        }
    },
    onTapCancelSeatSelection() {
        Odigeo.trigger(`${this.name}:resetCheckInSeatSelectionStep`);
        Odigeo.trigger(`${this.name}:trackCheckInCancelSeatSelection`);
    },
    onTapSeat: function(e) {
        const $el = this.$el.find(e.target);
        const seatStatus = this.getStatusValue($el);
        const sectionToTrack = this.section + 1;
        if (seatStatus === CONS.STATUS_AVAILABLE &&
            Odigeo._.size(this.seatMapSelectionCollection.getFlightSeats(this.section)) < this.nEligibleTravellers) {
            this.addSelectedSeat($el);
            Odigeo.Session.set(CONS.NUM_SELECTED_SEATS, this.seatMapSelectionCollection.getSelectedSeatsLength());
            SeatsTracking.trackSelectSeat({passenger: this.getActivePassenger(), section: sectionToTrack}, 'click');
        } else if (seatStatus === CONS.STATUS_ACTIVE || seatStatus === CONS.STATUS_SELECTED) {
            this.removeSelectedSeat($el);
            Odigeo.Session.set(CONS.NUM_SELECTED_SEATS, this.seatMapSelectionCollection.getSelectedSeatsLength());
            SeatsTracking.trackSelectSeat({passenger: this.getActivePassenger(), section: sectionToTrack}, 'remove');
        }
        if (this.options.isSeatmapOnContinuance) {
            this.showCTABasedOnSelection();
        }
        Odigeo.trigger(this.name + ':updateSeatSelectionFees');
    },
    needMoveToNextSection: function() {
        const isPristineAndNotLastSection = this.isPristineMoveThrough && !this.isLastSection;
        const isValidSelectionForNextSeatmap = this.isCheckin() || this.options.isSeatmapOnContinuance || this.maxSeatSelectionReached();
        return isPristineAndNotLastSection && isValidSelectionForNextSeatmap && !this.options.summaryPopupAlreadyShown;
    },
    maxSeatSelectionReached: function() {
        return Odigeo._.size(this.seatMapSelectionCollection.getFlightSeats(this.section)) === this.nEligibleTravellers;
    },
    onTapConfirmSeats: function() {
        SeatsTracking.trackSeatsWidgetClick('confirm');
        if (this.needMoveToNextSection()) {
            this.moveToSection(this.nextAircraftData, true);
        } else if (this.options.isSeatmapOnContinuance) {
            this.triggerSeatmapSummaryPopup(true);
        } else {
            this.showUiDialogOK({fromConfirm: true});
        }
    },
    onTapRandomSelectionSeats() {
        SeatsTracking.trackContinueWithRandomSeats();
        this.triggerSeatmapSummaryPopup(true);
    },
    triggerSeatmapSummaryPopup(setOpened) {
        this.options.summaryPopupAlreadyShown = true;
        Odigeo.trigger(`${this.name}:setSeatmapSummaryPopupStatus`, setOpened);
    },
    resetDefaultBehaviourAfterOpenedSeatmap() {
        this.$cachedSelectors.aircraftmapConfirmButton.toggleClass('odf-hidden', false);
        this.$cachedSelectors.aircraftmapRandomSelectionButton.toggleClass('odf-hidden', true);
        Odigeo.trigger(`${this.name}:resetDefaultBehaviourAfterOpenedSeatmap`, this.options.summaryPopupAlreadyShown);
        this.options.isSeatmapOnContinuance = false;
        this.options.summaryPopupAlreadyShown = false;
    },
    onTapUpAircraftMap: function() {
        this.$cachedSelectors.aircraftmapContent.animate({scrollTop: 0}, 300);
    },
    onTapDeleteButton: function(e) {
        const $el = this.$el.find(e.target);
        const divId = $el.parent().parent().attr('id');
        const searchPattern= {numPassenger: parseInt(divId.charAt(divId.length-1), 10), section: this.section};
        this.removeSelection(this.seatMapSelectionCollection.getSeat(searchPattern));
        Odigeo.Session.set(CONS.NUM_SELECTED_SEATS, this.seatMapSelectionCollection.getSelectedSeatsLength());
        SeatsTracking.trackSelectSeat({passenger: this.getActivePassenger(), section: this.section + 1}, 'remove');
    },
    onOpenSidebarLegendLayer(trackAction) {
        this.drawerLegendModel.set('enabled', true);
        SeatsTracking.trackTapLegendMobile(trackAction);
    },
    onOpenSidebarLegendFromIcon() {
        this.onOpenSidebarLegendLayer('open');
    },
    onOpenSidebarLegendFromLink() {
        this.onOpenSidebarLegendLayer('more');
    },
    setActivePassengerTab: function(passengerId) {
        const $target = this.$cachedSelectors.aircraftmapPassengerTabContainer.find('.aircraftmap_passenger_tab[data-paxid=' + passengerId + ']');
        $target.siblings().removeClass('active');
        $target.addClass('active');

        if (!this.noSeatsAvailable && this.nEligibleTravellers > 2) {
            this.scrollToTab($target);
        }
    },
    scrollToTab: function($passengerTab) {
        this.$cachedSelectors.aircraftmapPassengerTabContainer.animate(
            {scrollLeft: $passengerTab.position().left},
            CONS.TAB_SCROLL_ANIMATION_TIME
        );
    },
    openAircraftMap: function(seatMap, aircraftOption) {
        this.openAircraftMapSetup(seatMap, aircraftOption);
        this.setUpView(seatMap, aircraftOption);
        this.updateShoppingCart();

        if (this.noSeatsAvailable) {
            this.createAircraftMapNoSeats();
        } else {
            this.createAircraftMap(aircraftOption);
            this.scrollToTop();
        }

        this.renderAircraftMapContainer(this.noSeatsAvailable);
        this.showAircraftMap();

        if (!this.infantMessageDismissed) {
            this.showInfantMessage();
        }

        if (this.isCheckin()) {
            this.handleOpenAircraftMapInCheckIn();
        }
    },
    showInfantMessage: function() {
        const infantOnBoard = this.passengerCollection.containPassengerType(CONS.PASSENGER_TYPE_INFANT);
        let infantMessageLightbox;

        if (infantOnBoard) {
            infantMessageLightbox = new Odigeo.UIElements.Lightbox(this.$cachedSelectors.aircraftmapInfantMessage);
            infantMessageLightbox.toggle(true);
        }
        this.infantMessageDismissed = true;
    },
    createAircraftMap: function(options) {
        this.renderAircraftTitle();
        this.renderAircraftMoveButtons();
        this.renderAircraftStructure(options);
        this.renderPassengers();
        this.renderPrimePill();
        if (this.options.isSeatmapOnContinuance) {
            this.showCTABasedOnSelection();
        }
        this.render();
    },
    createAircraftMapNoSeats: function() {
        this.renderAircraftNoSeatsNextSection();
        this.renderAircraftTitle();
        this.render();
        this.createNoSeatsAutoMove();
    },
    createNoSeatsAutoMove: function() {
        const isLastSectionOnContinuance = this.options.isLastItinerarySection && this.options.isSeatmapOnContinuance;
        if (this.infantMessageDismissed && !isLastSectionOnContinuance) {
            this.noSeatsAutoMoveTimeout = setTimeout(Odigeo._.bind(function() {
                this.onTapMoveToNextSection();
            }, this), CONS.TIMEOUT_NO_SEATS_AUTO_MOVE);
        }
    },
    renderAircraftNoSeatsNextSection: function() {
        this.$cachedSelectors.aircraftmapNoSeatmapWrapper.data('segment', this.nextAircraftData.segment);
        this.$cachedSelectors.aircraftmapNoSeatmapWrapper.data('section', this.nextAircraftData.section);
        this.$cachedSelectors.aircraftmapPassengerTabContainer.addClass('odf-hidden');
        this.$cachedSelectors.aircraftmapPrimePillContainer.addClass('odf-hidden');
        this.$cachedSelectors.aircraftmapNoSeatmapButtonTextLast.toggleClass('odf-hidden', !this.isLastSection);
        this.$cachedSelectors.aircraftmapNoSeatmapButtonText.toggleClass('odf-hidden', this.isLastSection);
    },
    renderAircraftMapContainer: function(noSeatsAvailable) {
        this.$cachedSelectors.aircraftmapNoSeatmapWrapper.toggleClass('odf-hidden', !noSeatsAvailable);
        this.$cachedSelectors.aircraftmapSeatmapWrapper.toggleClass('odf-hidden', noSeatsAvailable);
        this.$cachedSelectors.aircraftmapWrapper.removeClass('odf-hidden');
    },
    render: function() {
        this.renderPassengersInfo();
        this.renderSelection();
        this.updateCommonElements();
    },
    setUpView: function(seatMap, aircraftOption) {
        const completeOptions = Object.assign({}, aircraftOption, Odigeo.BagsAndSeats);
        this.options = Object.assign({}, this.options, completeOptions);
        this.seatMap = seatMap;
        this.noSeatsAvailable = Odigeo._.isEmpty(seatMap);
        this.nTravellers = this.options.nTravellers;
        this.nEligibleTravellers = this.getEligibleTravellers();
        this.section = this.options.section;
        this.segment = this.options.segment;
        this.flightSection = this.options.flightSection;
        this.flightSectionDetail = this.options.flightSectionDetail;
        this.arrivalCityName = this.options.arrivalCityName;
        this.departureCityName = this.options.departureCityName;
        this.fromPrice = this.options.fromPrice;
        this.defaultPassengerSelectString = this.options.defaultPassengerSelectString;
        this.isPristineMoveThrough = this.options.pristineMoveThrough;
        this.nextSectionTextItinerary = this.options.nextSectionTextItinerary;
        this.nextSectionDepartureDate = this.options.nextSectionDepartureDate;
        this.nextSectionDeparture = this.options.nextSectionDeparture;
        this.nextSectionArrival = this.options.nextSectionArrival;
        this.nextSectionText = this.options.nextSectionText;
        this.isLastSection = this.options.isLastItinerarySection || Odigeo._.isEmpty(this.nextSectionText);
        this.prevSectionText = this.options.prevSectionText;
        this.prevAircraftData = {
            segment: this.options.prevSegmentId,
            section: this.options.prevSectionId,
        };
        this.nextAircraftData = {
            segment: this.options.nextSegmentId,
            section: this.options.nextSectionId,
        };
        this.noSeatsAutoMoveTimeout;
        if (this.isCheckin()) {
            this.$cachedSelectors.aircraftmapCancelSelectionWrapper.removeClass('odf-hidden');
        }
        Odigeo.trigger(this.name + ':listenAircraftMapToClosePopup');
    },
    renderAircraftTitle: function() {
        this.$cachedSelectors.aircrafmapFlightSectionTextDetail.html(this.flightSectionDetail);
        this.$cachedSelectors.aircrafmapFlightSectionText.html(this.templates.aircraftTitle({
            departureCityName: this.departureCityName,
            arrivalCityName: this.arrivalCityName,
        }));
    },
    renderAircraftMoveButtons: function() {
        const showPrev = this.prevSectionText;
        const showNext = this.nextSectionText;

        this.$cachedSelectors.aircraftmapMovePrevSection.toggleClass('odf-hidden', !showPrev);
        this.$cachedSelectors.aircraftmapMoveNextSection.toggleClass('odf-hidden', !showNext);
        this.$cachedSelectors.aircraftmapMoveNextSection.data('segment', this.nextAircraftData.segment);
        this.$cachedSelectors.aircraftmapMoveNextSection.data('section', this.nextAircraftData.section);
        this.$cachedSelectors.aircraftmapMovePrevSection.data('segment', this.prevAircraftData.segment);
        this.$cachedSelectors.aircraftmapMovePrevSection.data('section', this.prevAircraftData.section);
        this.$cachedSelectors.aircraftmapNextSectionIata.html(this.nextSectionText);
        this.$cachedSelectors.aircraftmapPrevSectionIata.html(this.prevSectionText);
    },
    isFirstSection() {
        return !this.prevSectionText;
    },
    onTapMoveToOtherSection: function(ev) {
        const sectionData = $(ev.currentTarget).data();

        this.moveToSection(sectionData, false);
        const changeTo = Odigeo._.isEqual(this.nextAircraftData, sectionData) ? 'next' : 'prev';
        SeatsTracking.trackNavigateSection(changeTo, sectionData.section);
    },
    onTapMoveToNextSection: function() {
        clearTimeout(this.noSeatsAutoMoveTimeout);
        SeatsTracking.trackNavigateSection('next', this.section + 1);
        this.moveToSection(this.nextAircraftData, true);
    },
    moveToSection: function(sectionData, showMoveToSectionDialog) {
        if (this.isLastSection && showMoveToSectionDialog) {
            this.showUiDialogOK({fromAutoConfirm: true});
        } else {
            const seatSelectionType = aircraftMapUtils.getLastSeatSelectionType(this.$el, CONS.SELECTED_SEAT_SELECTOR);
            if (showMoveToSectionDialog) {
                this.showMoveToSectionDialog(this.nextAircraftData, seatSelectionType);
            } else {
                const moveToOtherSectionEventId = `moveToOtherSection${this.getCheckinEventSuffix()}`;
                Odigeo.trigger(`${this.name}:${moveToOtherSectionEventId}`, sectionData, seatSelectionType);
            }
        }
    },
    renderPassengersInfo: function() {
        this.passengerCollection.each(function(model) {
            const idPassenger = model.get('numPassenger');
            const passengerDivId = this.getPassengerDivId(idPassenger);
            const searchPattern = {numPassenger: idPassenger, section: this.section};
            const seatSelected = this.seatMapSelectionCollection.getSeat(searchPattern);
            const isSeatSelected = !Odigeo._.isEmpty(seatSelected);
            const deleteButtonStatus = isSeatSelected ? CONS.STATUS_VISIBLE : CONS.STATUS_HIDDEN;
            const priceDetails = this.getSeatInfo(isSeatSelected, seatSelected);

            this.setStatusValue(this.$el.find(passengerDivId), CONS.STATUS_INACTIVE);
            this.setStatusValue(this.$el.find(passengerDivId + ' .aircraftmap_user_delete'), deleteButtonStatus);

            this.$el.find(passengerDivId + ' .aircraftmap_user_selection .aircraftmap_user_seat')
                .html(priceDetails.seat + (priceDetails.isPrimePrice ? '' : priceDetails.total));
            this.$el.find(passengerDivId + ' .aircraftmap_user_selection .aircraftmap_seat_price')
                .html(priceDetails.isPrimePrice ? priceDetails.total : '');
            this.$el.find(passengerDivId + ' .aircraftmap_user_selection .aircraftmap_seat_discount')
                .html(priceDetails.isPrimePrice ? priceDetails.discount : '');
            if (!Odigeo._.isEmpty(model.get('name'))) {
                this.$el.find(passengerDivId + ' .aircraftmap_user_name').html(model.get('name'));
            }
        }, this);
        this.setActivePassengerTab(this.getActivePassenger());
    },
    renderAircraftStructure: function(options) {
        const aircraftTemplate = this.buildTemplate(options);
        this.$cachedSelectors.aircraftContainer.empty().html(aircraftTemplate);
        this.renderAvailableSeats();
        const seatTypeAvailable = aircraftMapUtils.getSeatTypeAvailable(aircraftTemplate);
        this.initAircraftLegend(seatTypeAvailable);
    },
    renderPassengers: function() {
        this.$cachedSelectors.aircraftmapPassengerTabContainer.removeClass('odf-hidden');
        this.$cachedSelectors.aircraftmapPassengerTabContainer.html(this.templates.aircraftmapPassengers({
            passengers: this.passengerCollection.toJSON(),
            seatMapPassengersClass: this.nEligibleTravellers > 2 ? 'several' : this.nEligibleTravellers == 2 ? 'two' : 'one',
            keys: this.keys,
        }));
    },
    renderPrimePill: function() {
        if (this.options.isSeatmapOnContinuance && this.options.primeInfo.isPrimeView) {
            this.$cachedSelectors.aircraftmapPrimePillContainer.removeClass('odf-hidden');
            const discountPercentageKey = this.keys.discountUpTo.charAt(0) + this.keys.discountUpTo.slice(1).toLowerCase();
            this.$cachedSelectors.aircraftmapPrimePillContainer.html(this.templates.aircraftmapPrimePill({
                discountPercentageKey,
                maxDiscountPercentage: this.options.primeInfo.maxDiscountPercentage,
            }));
        } else {
            this.$cachedSelectors.aircraftmapPrimePillContainer.addClass('odf-hidden');
        }
    },
    showCTABasedOnSelection() {
        const hasSelectedAnySeat = this.seatMapSelectionCollection.getFlightSeats(this.section)?.length !== 0;
        this.setStatusValue(this.$cachedSelectors.aircraftmapConfirmContainer, CONS.STATUS_VISIBLE);
        this.$cachedSelectors.aircraftmapConfirmButton.toggleClass('odf-hidden', !hasSelectedAnySeat);
        this.$cachedSelectors.aircraftmapRandomSelectionButton.toggleClass('odf-hidden', hasSelectedAnySeat);
    },
    renderAvailableSeats: function() {
        this.seatMapDescriptorCollection.each(function(model) {
            const $seatDivId = this.$el.find(this.getSeatDivId(model.get('seatRow'), model.get('column')));
            const isNoSeat = model.get('type') === 'NO_SEAT';
            const status = isNoSeat ? CONS.STATUS_NO_SEAT : CONS.STATUS_AVAILABLE;

            this.setStatusValue($seatDivId, status);
            this.updateSelectedSeat($seatDivId, {select: false});
        }, this);
    },
    renderSelection: function() {
        this.renderAvailableSeats();
        const seatsSelectionOfAircraft = this.seatMapSelectionCollection.getFlightSeats(this.section);
        Odigeo._.each(seatsSelectionOfAircraft, function(model) {
            if (this.passengerCollection.getPassenger.length) {
                const $seatDivId = this.$el.find(this.getSeatDivId(model.get('rowSelection'), model.get('columnSelection')));
                const status = this.isSelectedStatus(model.get('numPassenger')) ? CONS.STATUS_SELECTED : CONS.STATUS_ACTIVE;

                this.setStatusValue($seatDivId, status);
                this.updateSelectedSeat($seatDivId, {select: true});
            }
        }, this);
    },
    updateSelectedSeat: function($seat, options) {
        const characteristic = $seat.data('characteristic');
        const seatTypeIconClass = aircraftMapUtils.getSeatCharacteristicClassByType(characteristic, 'icon');
        if (options.select) {
            $seat.removeClass(seatTypeIconClass).addClass('odf-icon-pax');
        } else {
            $seat.removeClass('odf-icon-pax').addClass(seatTypeIconClass);
        }
    },
    addSelectedSeat: function($el) {
        const searchPattern = {seatRow: $el.data('row'), column: $el.data('column')};
        const seat = {
            numPassenger: this.getActivePassenger(),
            segment: this.segment,
            section: this.section,
            seat: this.seatMapDescriptorCollection.getSeat(searchPattern),
        };
        this.addSelection(seat);
    },
    removeSelectedSeat: function($el) {
        const searchPattern = {rowSelection: $el.data('row'), columnSelection: $el.data('column'), section: this.section};
        this.removeSelection(this.seatMapSelectionCollection.getSeat(searchPattern));
    },
    isCheckin() {
        return this.id === CONS.AIRCRAFT_MOBILE_ID;
    },
    getCheckinEventSuffix() {
        return this.isCheckin() ? 'CheckIn' : '';
    },
    closeAircraftMap: function(source = {}) {
        const closeAircraftMapEventId = `closeAircraftMap${this.getCheckinEventSuffix()}`;
        if (this.noSeatsAutoMoveTimeout) {
            clearTimeout(this.noSeatsAutoMoveTimeout);
        }
        if (source.fromBackIcon) {
            Odigeo.trigger(`${this.name}:popBrowserHistory`);
        }
        if (!this.isPristineMoveThrough) {
            source.fromChange = true;
        }
        Odigeo.trigger(this.name + ':toggleMainLayout', false);
        Odigeo.trigger(`${this.name}:${closeAircraftMapEventId}`, source);
    },
    trackCloseAircraftMap: function() {
        Odigeo.trigger(this.name + ':trackCloseAircraftMap');
    },
    onCloseAircraftMap: function(source) {
        if (this.isCheckin()) {
            this.handleCloseAircraftMapInCheckIn(source);
        } else {
            this.setStatusValue(this.$cachedSelectors.aircraftmapWrapper, CONS.STATUS_CLOSED);
            this.scrollToTop();
        }
    },
    handleCloseAircraftMapInCheckIn(source) {
        if (this.seatMapSelectionCollection.hasSelectedAnySeat()) {
            this.setStatusValue(this.$cachedSelectors.aircraftmapWrapper, CONS.STATUS_CLOSED);
            this.scrollToTop();
            Odigeo.trigger(`${this.name}:moveToSeatPaymentCheckIn`, source);
        } else {
            Odigeo.trigger(`${this.name}:resetCheckInSeatSelectionStep`);
        }
    },
    handleOpenAircraftMapInCheckIn() {
        Odigeo.trigger(`${this.name}:moveToSeatSelectionCheckIn`);
    },
    showAircraftMap: function() {
        this.scrollToSeats();
        this.setStatusValue(this.$cachedSelectors.aircraftmapWrapper, CONS.STATUS_VISIBLE);
        Odigeo.trigger(this.name + ':toggleMainLayout', true);
        this.hideErrorMessage();
    },
    scrollToSeats: function() {
        const $selectedSeats = this.$el.find(CONS.SELECTED_SEAT_SELECTOR);
        const $firstSelectedSeat = $selectedSeats.first();

        if ($firstSelectedSeat.length) {
            Odigeo.Utils.scrollToElement($firstSelectedSeat, {
                container: '.aircraftmap_content',
                animation: false,
                extraTop: CONS.SCROLL_SEAT_OFFSET,
            });
        } else {
            this.scrollToCheapestSeat();
        }
    },
    scrollToCheapestSeat: function() {
        const lastSeatSelectionType = Odigeo._.get(this.options, 'lastSeatSelectionType', '');
        const lastSeatSelectedClass = aircraftMapUtils.getSeatCharacteristicClassByType(lastSeatSelectionType);

        const $targetSeat = aircraftMapUtils.getSeatByClasses(this.$el, [
            `.${lastSeatSelectedClass}`,
            `[data-rawprice="${+this.fromPrice}"]`,
            CONS.AVAILABLE_SEAT_SELECTOR,
        ]);

        if ($targetSeat && $targetSeat.length) {
            Odigeo.Utils.scrollToElement($targetSeat, {
                container: '.aircraftmap_content',
                animation: true,
                extraTop: CONS.SCROLL_SEAT_OFFSET,
                animationSpeed: 500,
                delay: 400,
                onComplete: () => {
                    this.displayAircraftSeatLegendTooltip();
                },
            });
        }
    },
    scrollToTop: function() {
        Odigeo.Utils.scrollToElement($('body'), {
            container: '.aircraftmap_content',
            animation: false,
        });
    },
    showMoveToSectionDialog: function(sectionData, seatSelectionType) {
        this.$cachedSelectors.aircraftmapNextSectionItinerary.html(this.templates.aircraftTitle({
            departureCityName: this.nextSectionDeparture,
            arrivalCityName: this.nextSectionArrival,
        }));

        const {primeInfo} = this.options;
        const {hasDiscountAmount, currencyFormattedDiscount} = this.getCurrencyFormattedSeatsDiscount();
        const showSavedAmount = hasDiscountAmount && primeInfo.isPrimeView;
        const savedAmountMessage = showSavedAmount
            ? Odigeo.Utils.replaceCmsKeyArgs(this.keys.aircraftMapFeedbackMessage, currencyFormattedDiscount)
            : '';

        this.$cachedSelectors.aircraftmapSavedAmountItinerary.html(savedAmountMessage);
        this.$cachedSelectors.aircraftmapNextSectionDepartureDate.html(this.nextSectionDepartureDate);
        this.setStatusValue(this.$cachedSelectors.aircraftmapUiDialogNextFlight, CONS.STATUS_VISIBLE);
        this.$cachedSelectors.aircraftmapEmergentLayer.animate({'opacity': 1}, 300, 'swing');
        setTimeout(Odigeo._.bind(function() {
            const moveToOtherSectionEventId = `moveToOtherSection${this.getCheckinEventSuffix()}`;
            this.$cachedSelectors.aircraftmapEmergentLayer.css('opacity', '0');
            this.setStatusValue(this.$cachedSelectors.aircraftmapUiDialogNextFlight, CONS.STATUS_HIDDEN);
            Odigeo.trigger(`${this.name}:${moveToOtherSectionEventId}`, sectionData, seatSelectionType);
        }, this), CONS.TIMEOUT_DIALOG_MOVE_SECTION);
    },
    showUiDialogOK: function(source) {
        this.setStatusValue(this.$cachedSelectors.aircraftmapUidialogOK, CONS.STATUS_VISIBLE);
        this.$cachedSelectors.aircraftmapEmergentLayer.animate({'opacity': 1}, 300, 'swing');
        this.disablePristineMoveThrough();
        this.trackCloseAircraftMap();

        const {primeInfo} = this.options;
        const {hasDiscountAmount, currencyFormattedDiscount} = this.getCurrencyFormattedSeatsDiscount();
        let discountMsg = '';
        const showDiscountMessage = hasDiscountAmount && primeInfo.isPrimeView;
        if (showDiscountMessage) {
            discountMsg = primeInfo.isPrimeUser ? Odigeo.Utils.replaceCmsKeyArgs(this.keys.savedAmountPrimeRepeat, currencyFormattedDiscount) :
                Odigeo.Utils.replaceCmsKeyArgs(this.keys.savedAmountPrimeAcquisition, currencyFormattedDiscount);
        }
        this.$cachedSelectors.aircraftmapSavedAmount.html(discountMsg);

        setTimeout(Odigeo._.bind(function() {
            this.$cachedSelectors.aircraftmapEmergentLayer.css('opacity', '0');
            this.setStatusValue(this.$cachedSelectors.aircraftmapUidialogOK, CONS.STATUS_HIDDEN);
            this.closeAircraftMap(source);
        }, this), CONS.TIMEOUT_DIALOG_OK);
    },
    getCurrencyFormattedSeatsDiscount: function() {
        const decimalPlaces = this.seatMapSelectionCollection.totalSeatsPrice > 0 ? 2 : 0;
        const currency = Odigeo._.clone(Odigeo.Utils.Currency, {decimalPlaces: decimalPlaces});
        const selectedSeatsDiscountAmount = this.seatMapSelectionCollection.getSelectedSeatsDiscountAmount();
        const hasDiscountAmount = selectedSeatsDiscountAmount > 0;
        const currencyFormattedDiscount = Odigeo.Utils.formatCurrency(selectedSeatsDiscountAmount, currency);
        return {
            hasDiscountAmount,
            currencyFormattedDiscount,
        };
    },
    disablePristineMoveThrough: function() {
        if (this.isPristineMoveThrough) {
            Odigeo.trigger(this.name + ':disablePristineMoveThrough');
        }
    },
    updateCommonElements: function() {
        const seatMapSelectionCollectionSize = Odigeo._.size(this.seatMapSelectionCollection.getFlightSeats(this.section));
        const maxSelected = seatMapSelectionCollectionSize === this.nEligibleTravellers;
        const confirmButtonStatus = maxSelected ? CONS.STATUS_VISIBLE : CONS.STATUS_HIDDEN;

        if (!this.options.isSeatmapOnContinuance) {
            this.setStatusValue(this.$cachedSelectors.aircraftmapConfirmContainer, this.isCheckin() ? CONS.STATUS_VISIBLE : confirmButtonStatus);
        }
    },
    getSeatInfo: function(isSeatSelected, seat) {
        const seatDetails = {
            seat: this.defaultPassengerSelectString,
            total: '',
            discount: '',
            isPrimePrice: false,
        };

        if (isSeatSelected) {
            const totalPrice = seat.get('totalPrice');
            const primePrice = seat.get('totalPrimePrice');
            seatDetails.total = `(+${Odigeo.Utils.formatCurrency(totalPrice)})`;
            seatDetails.isPrimePrice = this.options.primeInfo.isPrimeView && primePrice < totalPrice;

            seatDetails.seat = seat.get('rowSelection') + seat.get('columnSelection') + ' ';

            if (seatDetails.isPrimePrice) {
                seatDetails.discount += ' ' + Odigeo.Utils.formatCurrency(primePrice);
            }
        }

        return seatDetails;
    },
    getEligibleTravellers: function() {
        return this.passengerCollection.reduce(
            function(totalElegible, currentPax) {
                return currentPax.get('travellerType') !== 'INFANT' ? totalElegible + 1 : totalElegible;
            }, 0);
    },
    isSelectedStatus: function(idPassenger) {
        return this.maxSeatSelectionReached() && this.getActivePassenger() === idPassenger;
    },
    getActivePassenger: function() {
        var lastTravellerIdx = this.nTravellers;
        var activePassenger = 1;
        var searchPattern;
        var currentPassengerType;

        if (this.maxSeatSelectionReached()) {
            activePassenger = this.passengerCollection.getLastNumPassengerExcludingType(CONS.PASSENGER_TYPE_INFANT);
        } else {
            for (let paxCounter = lastTravellerIdx; paxCounter >= 1; paxCounter--) {
                currentPassengerType = this.passengerCollection.getPassenger({numPassenger: paxCounter}).get('travellerType');
                if (currentPassengerType != CONS.PASSENGER_TYPE_INFANT) {
                    searchPattern = {numPassenger: paxCounter, section: this.section};
                    activePassenger = Odigeo._.isUndefined(this.seatMapSelectionCollection.getSeat(searchPattern)) ? paxCounter : activePassenger;
                }
            }
        }
        return activePassenger;
    },
    hideErrorMessage: function() {
        Odigeo.trigger(this.name + ':hideErrors');
    },
    setStatusValue: function($e, value) {
        $e.attr(CONS.DATA_STATUS, value);
    },
    getStatusValue: function($e) {
        return $e.attr(CONS.DATA_STATUS);
    },
    getSeatDivId: function(row, column) {
        return '#aircraft_map' +
            '_' + row + column;
    },
    getPassengerDivId: function(idPassenger) {
        return '#aircraft_map' +
            '_passenger_' + idPassenger;
    },
    renderDrawerSeatLegend(seatAvailabilityByType) {
        this.drawerAircraftmapLegend = this.drawerAircraftmapLegend ? this.drawerAircraftmapLegend.destroy() : null;
        this.drawerAircraftmapLegend = drawerAircraftmapLegendFactory.create({
            el: this.$cachedSelectors.aircraftmapLegendSidebarWrapper,
            keys: {
                title: this.keys.aircraftmapSeatLegendTitle,
            },
            seatAvailabilityByType,
            onCloseDrawer: () => {
                SeatsTracking.trackTapLegendMobile('close');
            },
            model: this.drawerLegendModel,
        });
    },
    renderAircraftSeatLegend(seatAvailabilityByType) {
        aircraftmapLegendFactory.create({
            el: this.$cachedSelectors.aircrafmapLegend,
            seatAvailabilityByType,
        });
    },
    displayAircraftSeatLegendTooltip() {
        if (!this.seatLegendTooltipDisplayed) {
            this.seatLegendTooltipDisplayed = true;
            this.$cachedSelectors.aircraftmapLegendTooltipContainer.addClass('open');
            this.$el.on('touchstart', this.selectors.aircraftmapWrapper, () => {
                this.onTapAircraftmapWrapper();
            });
        }
    },
    onTapAircraftmapWrapper() {
        if (this.seatLegendTooltipDisplayed && this.$cachedSelectors.aircraftmapLegendTooltipContainer.hasClass('open')) {
            this.$cachedSelectors.aircraftmapLegendTooltipContainer.removeClass('open');
            this.$el.off('touchstart', this.selectors.aircraftmapWrapper);
        }
    },
    initAircraftLegend: function(seatAvailabilityByType) {
        this.renderDrawerSeatLegend(seatAvailabilityByType);
        this.renderAircraftSeatLegend(seatAvailabilityByType);
    },
    initialize: function() {
        this.init();
        this.drawerLegendModel = new DrawerModel();
    },
}))));
